import CurrentUser from './current-user';

export default CurrentUser;
